// extracted by mini-css-extract-plugin
export default {"container":"LinkList_container__r-7mS","item":"LinkList_item__kdxKT"};